
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireff32"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireff32"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f2DfV", function(module, exports) {
parcelRequire("hgMfA");
parcelRequire("4qUcH");

});
parcelRegister("hgMfA", function(module, exports) {
parcelRequire("5SEZ9");

var $gRYVR = parcelRequire("gRYVR");

var $8Sz5Z = parcelRequire("8Sz5Z");
let $c9295bd64a41d176$var$headerHeight = parseFloat(document.documentElement.style.getPropertyValue("--header-height"));
let $c9295bd64a41d176$var$lastHeaderPosition;
let $c9295bd64a41d176$var$newHeaderPosition;
const $c9295bd64a41d176$var$hideHeaderOnScroll = ()=>{
    $c9295bd64a41d176$var$lastHeaderPosition = window.scrollY;
    (0, $gRYVR.addClassItem)(".header", "scroll");
    if ($c9295bd64a41d176$var$headerHeight - 50 < $c9295bd64a41d176$var$lastHeaderPosition && $c9295bd64a41d176$var$lastHeaderPosition > $c9295bd64a41d176$var$newHeaderPosition) {
        (0, $gRYVR.addClassItem)(".header", "hide");
        (0, $gRYVR.addClassItem)(".header", "scroll");
    } else if ($c9295bd64a41d176$var$newHeaderPosition > $c9295bd64a41d176$var$lastHeaderPosition) (0, $gRYVR.removeClassItem)(".header", "hide");
    if ($c9295bd64a41d176$var$lastHeaderPosition < $c9295bd64a41d176$var$headerHeight) (0, $gRYVR.removeClassItem)(".header", "scroll");
    $c9295bd64a41d176$var$newHeaderPosition = $c9295bd64a41d176$var$lastHeaderPosition;
};
const $c9295bd64a41d176$var$throttleHideHeader = (0, $8Sz5Z.default)(()=>{
    $c9295bd64a41d176$var$hideHeaderOnScroll();
}, 250);
window.addEventListener("scroll", $c9295bd64a41d176$var$throttleHideHeader);
$c9295bd64a41d176$var$throttleHideHeader();

});
parcelRegister("5SEZ9", function(module, exports) {

$parcel$export(module.exports, "_classList", function () { return $4481c9bbb3854267$export$5ccb867f293e3c4c; });
$parcel$export(module.exports, "_add", function () { return $4481c9bbb3854267$export$eb19ebbec1ff9510; });
$parcel$export(module.exports, "_remove", function () { return $4481c9bbb3854267$export$7be779bc7f76622c; });
$parcel$export(module.exports, "_toggle", function () { return $4481c9bbb3854267$export$4b515c6f72c0fb7e; });
$parcel$export(module.exports, "_querySelector", function () { return $4481c9bbb3854267$export$242934abc2863db9; });
const $4481c9bbb3854267$export$c6742064fd272eef = "document", $4481c9bbb3854267$export$5ccb867f293e3c4c = "classList", $4481c9bbb3854267$export$eb19ebbec1ff9510 = "add", $4481c9bbb3854267$export$7be779bc7f76622c = "remove", $4481c9bbb3854267$export$4b515c6f72c0fb7e = "toggle", $4481c9bbb3854267$export$7a240564ed1f29c7 = "querySelectorAll", $4481c9bbb3854267$export$242934abc2863db9 = "querySelector";

});

parcelRegister("gRYVR", function(module, exports) {

$parcel$export(module.exports, "addClassItem", function () { return $c480dc6df3cf6d91$export$6e6f8e21af33b231; });
$parcel$export(module.exports, "removeClassItem", function () { return $c480dc6df3cf6d91$export$21b4674b9a6e7161; });

var $5SEZ9 = parcelRequire("5SEZ9");
const $c480dc6df3cf6d91$export$6e6f8e21af33b231 = (item, className)=>{
    document[$5SEZ9._querySelector](item)?.[$5SEZ9._classList][$5SEZ9._add](className);
};
const $c480dc6df3cf6d91$export$21b4674b9a6e7161 = (item, className)=>{
    document[$5SEZ9._querySelector](item)?.[$5SEZ9._classList][$5SEZ9._remove](className);
};
const $c480dc6df3cf6d91$export$5401572fb47f69f8 = (item, className)=>{
    document[$5SEZ9._querySelector](item)?.[$5SEZ9._classList][$5SEZ9._toggle](className);
};

});

parcelRegister("8Sz5Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $676e97262f31760a$export$2e2bcd8739ae039; });
function $676e97262f31760a$export$2e2bcd8739ae039(cb, delay = 1000) {
    let shouldWait = false;
    let waitingArgs;
    const timeoutFunc = ()=>{
        if (waitingArgs == null) shouldWait = false;
        else {
            cb(...waitingArgs);
            waitingArgs = null;
            setTimeout(timeoutFunc, delay);
        }
    };
    return (...args)=>{
        if (shouldWait) {
            waitingArgs = args;
            return;
        }
        cb(...args);
        shouldWait = true;
        setTimeout(timeoutFunc, delay);
    };
}

});


parcelRegister("4qUcH", function(module, exports) {
class $33a5300b9fcb4036$export$2e2bcd8739ae039 {
    constructor(element){
        this.element = element;
        this.summary = element.querySelector("summary");
        this.content = element.querySelector("summary + div");
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener("click", (e)=>{
            this.onClick(e);
        });
    }
    onClick(e) {
        e.preventDefault();
        this.element.style.overflow = "hidden";
        if (this.isClosing || !this.element.open) this.open();
        else if (this.isExpanding || this.element.open) this.shrink();
    }
    shrink() {
        this.isClosing = true;
        const startHeight = `${this.element.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;
        if (this.animation) this.animation.cancel();
        this.animationElement(startHeight, endHeight);
        this.animation.onfinish = ()=>this.onAnimationFinish(false);
        this.animation.oncancel = ()=>this.isClosing = false;
    }
    open() {
        this.shrink();
        this.element.style.height = `${this.element.offsetHeight}px`;
        this.element.open = true;
        window.requestAnimationFrame(()=>this.expand());
    }
    animationElement(startHeight, endHeight) {
        this.animation = this.element.animate({
            height: [
                startHeight,
                endHeight
            ]
        }, {
            duration: 400,
            easing: "ease"
        });
    }
    onAnimationFinish(open) {
        this.element.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.element.style.height = this.element.style.overflow = "";
    }
    expand() {
        this.isExpanding = true;
        const startHeight = `${this.element.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
        if (this.animation) this.animation.cancel();
        this.animationElement(startHeight, endHeight);
        this.animation.onfinish = ()=>this.onAnimationFinish(true);
        this.animation.oncancel = ()=>this.isExpanding = false;
    }
}
[
    ...document.querySelectorAll("details")
].forEach((el)=>{
    new $33a5300b9fcb4036$export$2e2bcd8739ae039(el);
});

});




parcelRequire("f2DfV");


//# sourceMappingURL=blog.77885efe.js.map
